/**
 * Programs slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';
import { Program } from '../../store/slices/types';

const initialState = {
  programs: [] as Program[],
  currentProgram: null as Program | null,
  loading: false,
  error: null as string | null,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
  },
};

const programsSlice = createSlice({
  name: 'programs',
  initialState,
  reducers: {
    setPrograms(state, action) {
      // Handle both array response and paginated response
      if (Array.isArray(action.payload)) {
        state.programs = action.payload;
      } else if (action.payload?.data) {
        state.programs = action.payload.data;
        if (action.payload.pagination) {
          state.pagination = {
            total: action.payload.pagination.total || action.payload.total || 0,
            page: action.payload.pagination.page || action.payload.page || 1,
            limit: action.payload.pagination.limit || action.payload.limit || 10,
          };
        }
      } else {
        state.programs = [];
      }
      state.loading = false;
      state.error = null;
    },
    setCurrentProgram(state, action) {
      state.currentProgram = action.payload;
      state.loading = false;
      state.error = null;
    },
    addProgram(state, action) {
      state.programs.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    updateProgram(state, action) {
      const index = state.programs.findIndex(
        (p) => (p._id || p.id) === (action.payload._id || action.payload.id)
      );
      if (index !== -1) {
        state.programs[index] = action.payload;
      }
      if (state.currentProgram && (state.currentProgram._id || state.currentProgram.id) === (action.payload._id || action.payload.id)) {
        state.currentProgram = action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    removeProgram(state, action) {
      state.programs = state.programs.filter(
        (p) => (p._id || p.id) !== action.payload
      );
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const programsReducer = programsSlice.reducer;

// Actions
export const {
  setPrograms,
  setCurrentProgram,
  addProgram,
  updateProgram,
  removeProgram,
  setLoading,
  setError,
  clearError,
} = programsSlice.actions;

// Async Actions
export const fetchPrograms = createAction<{ page?: number; limit?: number; activeOnly?: boolean } | undefined>('PROGRAMS/FETCH_ALL');
export const fetchProgram = createAction<string>('PROGRAMS/FETCH_ONE');
export const createProgram = createAction<Omit<Program, '_id' | 'id'>>('PROGRAMS/CREATE');
export const updateProgramAction = createAction<{ id: string; data: Partial<Program> }>('PROGRAMS/UPDATE');
export const deleteProgram = createAction<string>('PROGRAMS/DELETE');

